<template>
  <div
    :id="data._id"
    class="tree-node"
    :class="[data.active ? store.activatedClass : '', data.open ? store.openedClass : '', data.class]"
    :data-level="data.level"
    :aria-expanded="data.open"
    >
    <div
      v-if="!isRoot"
      class="tree-node-inner-back"
      :style="[innerBackStyle, data.innerBackStyle]"
      :class="[data.innerBackClass]"
      >
      <div class="tree-node-inner" :style="[data.innerStyle]" :class="[data.innerClass]">
        <slot :data="data" :store="store" :scope="scope" />
      </div>
    </div>

    <!-- Children -->
    <div class="tree-node-children">

      <template v-if="childrenVisible">
        <MyTreeNode
          v-for="child in data.children"
          :key="child._id"
          :data="child"
          :store="store"
          :indent="indent"
          :scope="scope"
          :usedKeys="usedKeys"
          >
          <template slot-scope="props">
            <slot :data="props.data" :store="props.store" :scope="props.scope" />
          </template>
        </MyTreeNode>
      </template>

      <NewFieldButton
        v-if="newFieldButtonVisible"
        class="tree-node__new-field-btn"
        :data="data"
        :title="`Add a field ${data.label ? 'to ' : ''}`"
        :titleStrong="data.label || ''"
        :store="store"
        :style="newFieldButtonStyle()"
        @click.native="handleAddNewField"
        />
    </div>
  </div>
</template>

<script>
import NewFieldButton from '@/components/NewFieldButton'
import { DraggableTreeNode } from 'vue-draggable-nested-tree'
import { MDSModalNewFieldModel } from '@/models/modal-datasets.model'

export default {
  name: 'MyTreeNode',
  components: {
    NewFieldButton,
  },
  extends: DraggableTreeNode,
  props: {
    indent: {
      type: Number,
      default: 0,
    },
    scope: String,
    usedKeys: Array,
  },
  computed: {
    childsVisible () {
      const { data } = this
      return data.children.length === 1 && data.children[0]._id === 'draggable_tree_drag_placeHolder'
        ? false
        : this.isRoot || data.children && data.children.length && data.open
    },
    newFieldButtonVisible () {
      const { data } = this
      return this.childsVisible || (this.data.type === 'repeater' && data.open) || (this.data.type === 'group' && data.open)
    },
  },
  methods: {
    handleAddNewField () {
      const props = new MDSModalNewFieldModel({
        parent: this.data,
        scope: this.scope,
        usedKeys: this.usedKeys,
      })
      this.$store.commit('modals/OPEN_MODAL', { name: 'ModalNewField', props })
    },
    newFieldButtonStyle () {
      const lvl = this.data.level
      return {
        paddingLeft: lvl * this.indent + 'px',
      }
    },

  },
}
</script>

<style lang="scss">
  .tree-node__new-field-btn {
    width: calc(100% + 2px);
    margin-left: -1px;
    margin-bottom: -1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MyTreeNode.vue